import { HttpInterceptorFn } from '@angular/common/http';

export const returnURLInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('interceptor', req.url);
  return next(req);
};
